var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 12V8.00001H24V12H20V14.6667H24V18.6667H26.6667V14.6667H30.6667V12H26.6667ZM12 16C14.9467 16 17.3334 13.6133 17.3334 10.6667C17.3334 7.72001 14.9467 5.33334 12 5.33334C9.05337 5.33334 6.66671 7.72001 6.66671 10.6667C6.66671 13.6133 9.05337 16 12 16ZM12 8.00001C13.4667 8.00001 14.6667 9.20001 14.6667 10.6667C14.6667 12.1333 13.4667 13.3333 12 13.3333C10.5334 13.3333 9.33337 12.1333 9.33337 10.6667C9.33337 9.20001 10.5334 8.00001 12 8.00001ZM20.52 19.4133C18.28 18.2667 15.3734 17.3333 12 17.3333C8.62671 17.3333 5.72004 18.2667 3.48004 19.4133C2.14671 20.0933 1.33337 21.4667 1.33337 22.96V26.6667H22.6667V22.96C22.6667 21.4667 21.8534 20.0933 20.52 19.4133ZM20 24H4.00004V22.96C4.00004 22.4533 4.26671 22 4.69337 21.7867C6.28004 20.9733 8.84004 20 12 20C15.16 20 17.72 20.9733 19.3067 21.7867C19.7334 22 20 22.4533 20 22.96V24Z",
    fill: "#A22E26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard4);
export default __webpack_public_path__ + "static/media/card4.811a02300695d51912a04872eee42195.svg";
export { ForwardRef as ReactComponent };